export default __webpack_public_path__ + "static/do-1b1fff9184dad1af21e2c87127ae0524.svg";